import React from 'react';
import LineGroupContainer from '../containers/LineGroupContainer';
import { CardTitle } from './Card';

export default class LineGroups extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      didAdd: false,
    };
    this.createAlt = this.createAlt.bind(this);
  }

  createAlt(e) {
    e.preventDefault();
    this.setState({ ...this.state, didAdd: true });
    this.props.onCreate();
  }

  render() {
    return (
      <div className="card mb-3 paper-shadow">
        <div className="card-body">
          <CardTitle title="Alternate options" className="mb-0" />
          {/* <div className="small">Keep polishing by brainstorming ideas.</div>
          <div className="small text-info">
            <b>NB. Does not work as intended yet!</b>
    </div> */}
        </div>
        {this.props.linegroups.length === 0 && (
          <div className="card-body mt-0 pt-0 text-muted">
            No alternative lines &ndash;
            <a href="#alt-lines" className="card-link ml-1" onClick={this.createAlt}>
              Add one
            </a>
          </div>
        )}
        {this.props.linegroups.map(linegroup => (
          <LineGroupContainer
            line={this.props.line}
            linegroup={linegroup}
            key={linegroup.id}
            autoFocus={this.state.didAdd}
            onSelectAlt={this.props.onSelectAlt}
          />
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LineGroups.js